module.exports = __webpack_public_path__ + "img/call_evaluate.3dfba79c.png";